module.exports = __webpack_public_path__ + "static/media/logo.55373f90.png";